import React from "react";
import { Row, Col } from "antd";
import GoogleLoader from "../../assets/Loader/GoogleSvgLoader/GoogleLoader";
import CustomButton from "../../common/Buttons/CustomButton";
import { backArrowIcon } from "../../assets/images";
import ProfileForm from "../../components/CreatePerson/Forms/ProfileForm";
import { useProfileForm } from "../../hooks/useProfileForm";
import { useHistory, useParams } from "react-router-dom";

function EditServiceUserContainer() {
  const history = useHistory();
  const params = useParams<{ personId: string }>();

  const { initialValues, isLoadingProfile } = useProfileForm(Number(params.personId));

  function handleBack() {
    history.goBack();
  }

  return isLoadingProfile ? (
    <GoogleLoader />
  ) : (
    <Row>
      <Col xs={2} lg={4} />
      <Col xs={20} lg={16}>
        <CustomButton
          text="Back"
          handlerFunction={handleBack}
          type="link"
          icon={backArrowIcon}
          className="backBtn"
        />
        <ProfileForm initialValues={initialValues} />
      </Col>
      <Col xs={2} lg={4} />
    </Row>
  );
}

export default EditServiceUserContainer;
